import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { AuthService } from 'src/app/utility/auth/auth.service';

import { AppComponent } from 'src/app/app.component';

import { 
	DashboardListComponent,
	DashboardSettingComponent, 
	DashboardCategoryListComponent, 
	DashboardCategoryDetailComponent, 
	DashboardItemDetailComponent  
} from '@serengeti/serengeti-dashboard';

const routes: Routes = [
	{ path: 'main', component: AppComponent, canActivate: [AuthService], children: [
		{ path: 'dashboard/config/setting', component: DashboardSettingComponent, outlet: 'content', data: { title: 'lib.dashboard.setting.title', root: true } },
		{ path: 'dashboard/config/list', component: DashboardCategoryListComponent, outlet: 'content', data: { title: 'lib.dashboard.category.list.title', root: true } },
		{ path: 'dashboard/config/create', component: DashboardCategoryDetailComponent, outlet: 'content', data: { title: 'lib.dashboard.category.create.title' } },
		{ path: 'dashboard/config/detail/:id/', component: DashboardCategoryDetailComponent, outlet: 'content', data: { title: 'lib.dashboard.category.detail.title' } },
		{ path: 'dashboard/config/detail/:id/item/create', component: DashboardItemDetailComponent, outlet: 'content', data: { title: 'lib.dashboard.category.detail.title' } },
		{ path: 'dashboard/list', component: DashboardListComponent, outlet: 'content', data: { title: 'lib.dashboard.layout.panel.title', root: true } },
	]}
];

@NgModule({
	declarations: [],
	imports: [
		RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload', useHash: true }),
		CommonModule
	]
})
export class AppRoutingDashboardModule { }



